import { useUpdateEffect } from '@cian/react-utils';

import { useQueryClient } from '@tanstack/react-query';

import { FetchGetInfiniteSearchResultDesktopLoadService } from '@/packages/query-state/shared/store/search-offers/v2/get-infinite-search-result-desktop/load';
import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';

export function useUpdateSimilarOffersOnListingUpdate(): void {
  const queryClient = useQueryClient();
  const { data } = useSearchOffersDesktopQuery({ notifyOnChangeProps: ['data'] });

  useUpdateEffect(() => {
    if (data) {
      new FetchGetInfiniteSearchResultDesktopLoadService(queryClient).setQueryDataFromOffersListing(data.pages[0]);
    }

    /**
     * @description тут смотрим за обновлением листинга, если листинг обновился, то нужно обновить первую страницу похожих объявлений
     */
  }, [data]);
}
